import { Action } from '@ngrx/store';
import { HttpError } from '@rd/types';
import {
  CreateRewardsPreferenceWithLoyaltyProgram,
  CreateRewardsPreferenceWithMembership,
  RewardsPreference,
  RewardsPreferenceType,
} from '../../types/rewards-preference.type';

export enum RewardsPreferenceActionTypes {
  LOAD_REWARDS_PREFERENCE = '[RewardsPreference] Load rewards preference',
  LOAD_REWARDS_PREFERENCE_SUCCESS = '[RewardsPreference] Load rewards preference Success',
  LOAD_REWARDS_PREFERENCE_FAIL = '[RewardsPreference] Load rewards preference Fail',

  CREATE_REWARDS_PREFERENCE = '[RewardsPreference] Create rewards preference',
  CREATE_REWARDS_PREFERENCE_SUCCESS = '[RewardsPreference] Create rewards preference Success',
  CREATE_REWARDS_PREFERENCE_FAIL = '[RewardsPreference] Create rewards preference Fail',
}

export class LoadRewardsPreference implements Action {
  readonly type = RewardsPreferenceActionTypes.LOAD_REWARDS_PREFERENCE;
}

export class LoadRewardsPreferenceSuccess implements Action {
  readonly type = RewardsPreferenceActionTypes.LOAD_REWARDS_PREFERENCE_SUCCESS;

  constructor(public payload: RewardsPreference | null) {}
}

export class LoadRewardsPreferenceFail implements Action {
  readonly type = RewardsPreferenceActionTypes.LOAD_REWARDS_PREFERENCE_FAIL;

  constructor(public payload: HttpError) {}
}

export class CreateRewardsPreference implements Action {
  readonly type = RewardsPreferenceActionTypes.CREATE_REWARDS_PREFERENCE;

  constructor(
    public payload: {
      rewardsPreference: RewardsPreferenceType;
      membership:
        | CreateRewardsPreferenceWithMembership
        | CreateRewardsPreferenceWithLoyaltyProgram;
    },
  ) {}
}

export class CreateRewardsPreferenceSuccess implements Action {
  readonly type =
    RewardsPreferenceActionTypes.CREATE_REWARDS_PREFERENCE_SUCCESS;

  constructor(public payload: RewardsPreference | null) {}
}

export class CreateRewardsPreferenceFail implements Action {
  readonly type = RewardsPreferenceActionTypes.CREATE_REWARDS_PREFERENCE_FAIL;

  constructor(public payload: HttpError) {}
}

export type RewardsPreferenceActions =
  | CreateRewardsPreference
  | CreateRewardsPreferenceSuccess
  | CreateRewardsPreferenceFail
  | LoadRewardsPreference
  | LoadRewardsPreferenceSuccess
  | LoadRewardsPreferenceFail;
